import { isFeatureEnabled } from 'owa-feature-flags';
import { AttachmentSuggestions, ReplyWithAttachmentSuggestion } from 'owa-mail-store';
import { trace } from 'owa-trace';
import {
    DEFAULT_MAXNUMBEROFATTACHMENTS,
    DEFAULT_MAXNUMBEROFATTACHMENTS_EXPERIMENT,
} from './constants';

export default function extractAttachmentSuggestions(
    replyWithSuggestions: AttachmentSuggestions,
    mruSuggestions: ReplyWithAttachmentSuggestion[]
): ReplyWithAttachmentSuggestion[] {
    const extractedSuggestions: ReplyWithAttachmentSuggestion[] = [];
    let attachmentSuggestion: ReplyWithAttachmentSuggestion = null;
    const maxNumberOfAttachments = isFeatureEnabled('doc-attachment-suggestedAttsFive')
        ? DEFAULT_MAXNUMBEROFATTACHMENTS_EXPERIMENT
        : DEFAULT_MAXNUMBEROFATTACHMENTS;

    if (replyWithSuggestions) {
        const sentencesWithAttachmentSuggestions: string[] = Object.keys(replyWithSuggestions);
        for (let i = 0; i < sentencesWithAttachmentSuggestions.length; i++) {
            const sentence = sentencesWithAttachmentSuggestions[i];
            const attachmentSuggestionsForSentence = replyWithSuggestions[sentence];
            for (let j = 0; j < attachmentSuggestionsForSentence.length; j++) {
                attachmentSuggestion = attachmentSuggestionsForSentence[j];
                if (attachmentSuggestion) {
                    if (extractedSuggestions.length < maxNumberOfAttachments) {
                        extractedSuggestions.push(attachmentSuggestion);
                    } else {
                        // We've hit the maximum number of attachments we can return.
                        return extractedSuggestions;
                    }
                } else {
                    trace.info('[extractAttachmentSuggestions] replyWith suggestion is null');
                }
            }
        }
    }

    if (mruSuggestions) {
        // Backfill with MRU suggestions
        for (
            let mruAttachmentIndex: number = 0;
            mruAttachmentIndex < mruSuggestions.length &&
            extractedSuggestions.length < maxNumberOfAttachments;
            mruAttachmentIndex++
        ) {
            attachmentSuggestion = mruSuggestions[mruAttachmentIndex];
            if (attachmentSuggestion) {
                extractedSuggestions.push(attachmentSuggestion);
            } else {
                trace.info('[extractAttachmentSuggestions] mru suggestion is null');
            }
        }
    }

    return extractedSuggestions;
}
